/* eslint-disable @angular-eslint/component-class-suffix */
import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";

@Component({
    selector: "app-side-menu",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./side-menu.component.html",
    styleUrls: ["./side-menu.component.scss"],
})
export class SideMenu {
    title = input.required<string>();
    logo = input<string>();
}
